import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Grid, Button, Dropdown, TextArea, Icon, Confirm } from 'semantic-ui-react';
import _ from 'lodash';
import GestioneProcessoImprese from '../../../shared/services/rpc/gestione-processo-imprese';

export default class ControlloSeniorManagerImpreseButton extends Component {
  constructor(props) {
    super(props);

    const { processoImprese } = props;

    this.state = {
      isNegativeButton: processoImprese.controlloSeniorManager,
      isOpen: false,
      isLoading: false,
      esitoControlloSenior: processoImprese.esitoControlloSeniorManager || 'Documentazione conforme',
      notaControlloSenior: processoImprese.notaControlloSeniorManager || '',
      isOpenConfirm: false,
    };
  }

  /** Open confirm to remove check of Senior Manager */
  openConfirm = () => this.setState({ isOpenConfirm: true });

  /** Open confirm to remove check of Senior Manager */
  closeConfirm = () => this.setState({ isOpenConfirm: false });

  /** Open modal to confirm check of Senior Manager */
  openModal = () => this.setState({ isOpen: true });

  /** Close modal to confirm check of Senior Manager */
  closeModal = () => this.setState({ isOpen: false });

  /** Apply check of Senior Manager */
  confermaControlloSenior = () => {
    this.setState({ isLoading: true });

    GestioneProcessoImprese.confermaSenior(
      this.props.processoImprese.id,
      this.state.esitoControlloSenior,
      this.state.notaControlloSenior
    )
      .then(() => {
        this.setState({ isNegativeButton: true, isOpen: false });
        this.props.notification().addNotification({
          message: 'Conferma Senior completata con successo.',
          level: 'success',
        });
      })
      .catch((errors) =>
        this.props.notification().addNotification({
          message: _.get(errors, 'data.detail') || 'Si è verificato un errore durante la conferma Senior.',
          level: 'error',
        })
      )
      .finally(() => this.setState({ isLoading: false }));
  };

  /** Remove check of Senior Manager */
  rimuoviConfermaControlloSenior = () => {
    this.setState({ isLoading: true });

    GestioneProcessoImprese.annullaConfermaSenior(this.props.processoImprese.id)
      .then(() => {
        this.setState({ isNegativeButton: false, isOpenConfirm: false });
        this.props.notification().addNotification({
          message: 'Annulla conferma Senior completata con successo.',
          level: 'success',
        });
      })
      .catch((errors) =>
        this.props.notification().addNotification({
          message: _.get(errors, 'data.detail') || 'Si è verificato un errore durante annulla conferma Senior.',
          level: 'error',
        })
      )
      .finally(() => this.setState({ isLoading: false }));
  };

  render() {
    const { isNegativeButton, isLoading, isOpen, esitoControlloSenior, notaControlloSenior, isOpenConfirm } =
      this.state;

    return (
      <span>
        {!isNegativeButton && (
          <Button positive icon labelPosition="left" type="button" onClick={this.openModal} loading={isLoading}>
            <Icon name="thumbs up" /> Controllo Senior Manager
          </Button>
        )}

        {isNegativeButton && (
          <Button color="red" icon labelPosition="left" type="button" onClick={this.openConfirm} loading={isLoading}>
            <Icon name="thumbs down" /> Annulla Controllo Senior Manager
          </Button>
        )}

        <Modal
          size="tiny"
          open={isOpen}
          onClose={this.closeModal}
          closeOnEscape={false}
          closeOnRootNodeClick={false}
          closeIcon
        >
          <Modal.Header>Conferma l’attività di controllo da parte del Senior Manager</Modal.Header>
          <Modal.Content>
            <Form>
              <Grid>
                <Grid.Row>
                  <Grid.Column width={16}>
                    <b style={{ display: 'block', marginBottom: '5px', marginTop: '10px' }}>
                      Esito Senior Manager <span style={{ color: 'red' }}>*</span>
                    </b>
                    <Dropdown
                      value={esitoControlloSenior}
                      onChange={(_event, { value }) => this.setState({ esitoControlloSenior: value })}
                      search
                      fluid
                      selection
                      placeholder="Esito Senior Manager"
                      options={[
                        {
                          key: 'Documentazione conforme',
                          value: 'Documentazione conforme',
                          text: 'Documentazione conforme',
                        },
                        {
                          key: 'Documentazione non conforme sanata',
                          value: 'Documentazione non conforme sanata',
                          text: 'Documentazione non conforme sanata',
                        },
                        {
                          key: 'Documentazione non conforme e non sanabile',
                          value: 'Documentazione non conforme e non sanabile',
                          text: 'Documentazione non conforme e non sanabile',
                        },
                      ]}
                    ></Dropdown>
                  </Grid.Column>
                  <Grid.Column width={16}>
                    <b style={{ display: 'block', marginBottom: '5px', marginTop: '10px' }}>Nota</b>
                    <TextArea
                      style={{ minHeight: 75 }}
                      label="Nota"
                      placeholder="Inserisci la tua nota"
                      value={notaControlloSenior}
                      onChange={(_e, { value }) => this.setState({ notaControlloSenior: value })}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Form>
            <div style={{ marginBottom: '50px', marginTop: '20px' }}>
              <Button
                floated="right"
                content="Conferma"
                labelPosition="right"
                icon="checkmark"
                onClick={this.confermaControlloSenior}
                positive
                loading={isLoading}
              />
              <Button
                floated="right"
                content="Annulla"
                labelPosition="right"
                icon="delete"
                onClick={this.closeModal}
                loading={isLoading}
              />
            </div>
          </Modal.Content>
        </Modal>

        <Confirm
          size="tiny"
          content="Sei sicuro di voler annullare l’attività di controllo da parte del Senior Manager?"
          open={isOpenConfirm}
          cancelButton="Annulla"
          confirmButton="Conferma"
          onCancel={this.closeConfirm}
          onConfirm={this.rimuoviConfermaControlloSenior}
        />
      </span>
    );
  }
}

ControlloSeniorManagerImpreseButton.propTypes = {
  processoImprese: PropTypes.object.isRequired,
  notification: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./app/components/ProcessoImpresa/ControlloSeniorManagerImpreseButton/index.js